/**
 *
 * Update Wire Service Constants
 *
 */

import { SERVICE_NAMESPACE } from 'common';

export const UPDATE_WIRES_URL = (apiUrl, transferId) => `${apiUrl}/evaluated_transfers/wire_deposits/${transferId}/updateWireDetails`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/updateWire`;

// Trigger a fetch request in sagas
export const UPDATE_WIRE_REQUEST = `${NAMESPACE}/UPDATE_WIRE_REQUEST`;

// Current status of the service
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const FAILURE = `${NAMESPACE}/FAILURE`;



// WEBPACK FOOTER //
// ./src/services/updateWire/constants.js